module.exports = "https://coursera_assets.s3.amazonaws.com/images/961e4c8f3af23338c6ab77797352ca7f.png";